import _ from "@lodash";
import { Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import React from "react";

const styles = theme => ({
    contrastBackground: {
        backgroundColor: theme.palette.background.paper,
        "& [class^='border-']": {
            borderColor: theme.palette.divider
        },
        "& [class*='border-']": {
            borderColor: theme.palette.divider
        }
    },
    bgLineHeaders: {
        backgroundColor: theme.palette.type === "dark" ? "#666" : "#F2F2F2"
    },
    bgLineDetails: {
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#FFF"
    },
    borderDestaque: {
        border: "1px solid " + (theme.palette.type === "dark" ? "#F2F2F2" : "#666")
    },
    bgColor: {
        height: 6,
        "& > div ": {
            backgroundColor: "#00D935",
        }
    }
});

class CaixaItemCard extends XAPPComponent {

    state = {
        expand: false,
    };

    componentDidMount() {
        this.setState(_.set({ ...this.state }, "expand", this.getStatus() !== "aprovado"));
    }

    getStatus = () => {
        const { data } = this.props;
        let AResponse = "pendente";
        if (!_.isNull(data) && !_.isNull(data.titulos)) {
            AResponse = _.findIndex(data.titulos, { validacao: null }) !== -1 ? "pendente" : "aprovado";
        }
        return AResponse;
    };

    getValorTotal = () => {
        const { data = null } = this.props;
        let AValor = 0;
        if (!_.isNull(data) && !_.isNull(data.titulos)) {
            data.titulos.forEach(titulo => {
                AValor += titulo.valor;
            });
        }
        return AValor;
    };

    render() {
        const { data, classes, xappRouteParams, getFilter, saveCaixa, isGestor = false, listItensFilter, lastItem, openDialog } = this.props;
        const { expand } = this.state;
        let AStatus = this.getStatus();
        const formatter = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        });

        return (
            <React.Fragment>
                <div
                    className={clsx("flex flex-col md:flex-row w-full min-h-32 mt-8 cursor-pointer  border-1", classes.contrastBackground)}
                    key={"Item" + data.idtarefaprocesso}
                    style={{ borderLeft: `8px solid ${AStatus === "aprovado" ? "#00D935" : "#F7C201"}` }}
                    onClick={() => this.setState(_.set({ ...this.state }, "expand", !expand))}
                >
                    <div className={clsx("flex flex-col w-full xs:border-b-1")}>
                        <Typography className="w-full whitespace-no-wrap overflow-x-auto overflow-y-hidden p-8 items-center justify-around">
                            {data.agendamento?.nome ?? data.titulos[0]?.nome}
                        </Typography>
                    </div>
                    <div className={clsx("flex flex-row w-full")} >
                        <div className="flex w-44 items-center">
                            <XAPPButton
                                tooltip={{ "placement": "top", "title": AStatus === "aprovado" ? "Aprovado" : "Existem itens pendentes" }}
                                className="p-6"
                                onClick={() => { }}
                                type="icon"
                                noHover
                                icon={AStatus === "aprovado" ? "done_all" : "warning"}
                                iconProps={clsx("text-28", AStatus === "aprovado" ? "text-green" : "text-yellow")}
                            />
                        </div>
                        <div className="flex flex-row min-w-72 p-8 items-center justify-around border-l-1 w-full">
                            <Typography className="whitespace-no-wrap text-center">
                                {data.agendamento?.data}
                            </Typography>
                        </div>
                        <div className="flex min-w-44 items-center">
                            <XAPPButton
                                tooltip={{
                                    "placement": "top",
                                    "title":
                                        <React.Fragment>
                                            <p>{"Profissional: " + data.agendamento?.profissionais}</p>
                                        </React.Fragment>
                                }}
                                className="p-6"
                                onClick={() => { }}
                                type="icon"
                                noHover
                                icon={"info"}
                                iconProps={"text-20"}
                            />
                        </div>
                        <div className="flex flex-row w-256 p-8 px-16 items-center justify-end border-l-1 xs:hidden">
                            <Typography className="whitespace-no-wrap text-center">
                                {formatter.format(this.getValorTotal())}
                            </Typography>
                        </div>
                        <XAPPButton
                            className="p-6"
                            onClick={() => { }}
                            type="icon"
                            icon={expand ? "arrow_up" : "arrow_down"}
                            iconProps={"text-20"}
                        />
                    </div>
                </div>
                <div className={clsx("flex flex-col w-full")}>
                    {expand &&
                        <React.Fragment>
                            {!_.isNull(data.titulos) ?
                                <div className={clsx(classes.borderDestaque, "flex flex-col w-full")}>
                                    <Typography className="whitespace-no-wrap text-center w-full sm:hidden leading-loose">
                                        {"Total: " + formatter.format(this.getValorTotal())}
                                    </Typography>
                                    {data.titulos.map(titulo => {
                                        return (
                                            <div key={titulo.idtarefaprocessoapontamento} className={clsx(classes.bgLineHeaders, "flex flex-col w-full items-center")}>
                                                <div className={"flex flex-row items-center w-full px-6 border-b-1"}>
                                                    <XAPPButton
                                                        tooltip={{ "placement": "top", "title": _.isNull(titulo) ? "Não recebido" : _.isNull(titulo.validacao) ? "Não aprovado" : "Aprovado" }}
                                                        className={("p-6 w-44", _.isNull(titulo) ? "text-yellow" : !_.isNull(titulo.validacao) && "text-green")}
                                                        onClick={() => { }}
                                                        type="Icon"
                                                        noHover
                                                        icon={_.isNull(titulo) ? "warning" : _.isNull(titulo.validacao) ? "timer" : "done_all"}
                                                        iconProps={"text-20"}
                                                    />
                                                    <Typography className="whitespace-no-wrap text-start w-full overflow-x-auto overflow-y-hidden">
                                                        {titulo.nome}
                                                    </Typography>
                                                    <Typography className="whitespace-no-wrap text-center w-full">
                                                        {formatter.format(titulo.valor)}
                                                    </Typography>
                                                    <Typography className="whitespace-no-wrap text-center w-full">
                                                        {formatter.format(titulo.taxas)}
                                                    </Typography>
                                                    <Typography className="whitespace-no-wrap text-center w-full">
                                                        {formatter.format(titulo.valortotal)}
                                                    </Typography>
                                                    <div className="flex min-w-96">
                                                        <XAPPButton
                                                            tooltip={{
                                                                "placement": "top",
                                                                "title":
                                                                    <React.Fragment>
                                                                        <p>{"Serviços: " + titulo.servicos}</p>
                                                                        {!_.isNull(titulo.baixa) && (
                                                                            <p>Este título encontra-se baixado. Para estonar, efetue a operação de estorno em contas a receber antes.</p>
                                                                        )}
                                                                    </React.Fragment>
                                                            }}
                                                            className="p-6"
                                                            onClick={() => { }}
                                                            type="icon"
                                                            noHover
                                                            icon={"info"}
                                                            iconProps={"text-20"}
                                                        />
                                                        {isGestor && _.isNull(titulo.baixa) &&
                                                            <XAPPButton
                                                                tooltip={{ "placement": "top", "title": "Estornar" }}
                                                                className="p-6 text-red"
                                                                onClick={() => {
                                                                    saveCaixa("ESTORNARITEMCAIXA", titulo, xappRouteParams, this.props.getFilter(), listItensFilter);
                                                                    if (lastItem)
                                                                    {
                                                                        openDialog(null);
                                                                    }
                                                                }}
                                                                type="Icon"
                                                                icon={"return"}
                                                                iconProps={"text-20"}
                                                            />
                                                        }
                                                        {isGestor && !_.isNull(titulo) && _.isNull(titulo.validacao) &&
                                                            <XAPPButton
                                                                tooltip={{ "placement": "top", "title": "Aprovar" }}
                                                                className="p-6 text-green"
                                                                onClick={() => {
                                                                    saveCaixa("VALIDARITEM", titulo, xappRouteParams, getFilter(), listItensFilter);
                                                                    if (lastItem)
                                                                    {
                                                                        openDialog(null);
                                                                    }
                                                                }}
                                                                type="Icon"
                                                                icon={"done"}
                                                                iconProps={"text-20"}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                                {!_.isNull(titulo) && titulo.itens?.map((parcela, x) => (
                                                    <div
                                                        key={x}
                                                        className={clsx(classes.bgLineDetails, "flex flex-row w-full py-4 px-8 items-center", titulo.itens.length > 1 && x < titulo.itens.length - 1 && "border-b-1")}>
                                                        <Typography className="whitespace-no-wrap text-center w-full">
                                                            {parcela.vencimento}
                                                        </Typography>
                                                        <Typography className="whitespace-no-wrap text-center w-full">
                                                            {formatter.format(parcela.valor)}
                                                        </Typography>
                                                        <Typography className="whitespace-no-wrap text-center w-full">
                                                            {formatter.format(parcela.taxas)}
                                                        </Typography>
                                                        <Typography className="whitespace-no-wrap text-center w-full">
                                                            {formatter.format(parcela.valortotal)}
                                                        </Typography>
                                                        <Typography className="whitespace-no-wrap text-center w-full">
                                                            {parcela.idpessoaformularioformapagamentodescricao}
                                                        </Typography>
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })}
                                </div>
                                :
                                <div className={clsx(classes.borderDestaque, "flex flex-col w-full")}>
                                    <Typography className="whitespace-no-wrap text-center w-full leading-loose">
                                        {"Sem parcelas"}
                                    </Typography>
                                </div>
                            }
                        </React.Fragment>
                    }
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CaixaItemCard);
